import { createRoutine } from 'redux-saga-routines';
import {
  GET_COMPANY_DATA,
  GET_COMPANY_SEASONS_VALUES,
  GET_COMPANY_VENUES,
  GET_COMPANY_UNPUBLISHED_SEASON,
  GET_COMPANY_CONTACT,
  ADD_AND_UPDATE_CONTACTS,
  UPDATE_COMPANY,
  SET_COMPANY,
  GET_MUSICAL_WORKS_LIST,
  GET_COMPANY_EDIT_SEASON,
  GET_COMPANY_IMAGES,
  GET_COMPANY_LS_VOD,
  GET_COMPANY_VIDEOS,
  SET_SEASONS,
  CLEAR_EDIT_SEASONS,
  GET_COMPANY_STAFF,
  UPDATE_COMPANY_INFO,
  UPDATE_COMPANY_VENUE,
  GET_COMPANY_DESCRIPTIONS,
  CREATE_COMPANY_DESCRIPTION,
  UPDATE_COMPANY_DESCRIPTION,
  DELETE_COMPANY_DESCRIPTION,
  UPDATE_COMPANY_VIDEO,
  ADD_COMPANY_VIDEO,
  DELETE_COMPANY_VIDEO,
  GET_COMPANY_PRODUCTIONS,
  GET_COMPANY_EMPLOYEES,
  GET_COMPANY_BANNER_IMAGES,
  GET_COMPANY_PRODUCTION_VIDEOS,
  GET_COMPANY_PRODCUTION_IMAGES,
  GET_COMPANY_SEARCH_PRODUCTIONS_LIST,
  GET_COMPANY_TRANSLATIONS,
  UPDATE_COMPANY_TRANSLATIONS,
  DELETE_COMPANY_TRANSLATIONS,
  SET_COMPANY_PRODUCTION_RENTAL_ACTION,
  UPDATE_RENTAL_INCLUDES_ACTION,
  GET_COMPANY_YOUNG_ARTIST_PROGRAM,
  DELETE_COMPANY_YOUNG_ARTIST_PROGRAM,
  CREATE_COMPANY_YOUNG_ARTIST_PROGRAM,
  GET_COMPANY_FESTIVAL,
  DELETE_COMPANY_FESTIVAL,
  CREATE_COMPANY_FESTIVAL,
  GET_ABOUT_COMPANY_VIDEO,
  GET_COMPANY_REVIEWS,
  GET_COMPANY_PRODUCTION_REVIEWS,
} from './constants';

export const getCompanyDataAction = createRoutine(GET_COMPANY_DATA);
export const getCompanyContactAction = createRoutine(GET_COMPANY_CONTACT);
export const getCompanyEditSeasonAction = createRoutine(GET_COMPANY_EDIT_SEASON);
export const getCompanyUnpublishedSeasonAction = createRoutine(GET_COMPANY_UNPUBLISHED_SEASON);
export const getCompanySeasonsValueAction = createRoutine(GET_COMPANY_SEASONS_VALUES);
export const getCompanyVenuesAction = createRoutine(GET_COMPANY_VENUES);
export const addAndUpdateContactsAction = createRoutine(ADD_AND_UPDATE_CONTACTS);
export const updateCompanyAction = createRoutine(UPDATE_COMPANY);
export const getMusicalWorksListAction = createRoutine(GET_MUSICAL_WORKS_LIST);
export const getCompanyImagesAction = createRoutine(GET_COMPANY_IMAGES);
export const getCompanyProductionImagesAction = createRoutine(GET_COMPANY_PRODCUTION_IMAGES);
export const getCompanyBannerImagesAction = createRoutine(GET_COMPANY_BANNER_IMAGES);
export const getCompanyVideosAction = createRoutine(GET_COMPANY_VIDEOS);
export const getCompanyProductionVideosAction = createRoutine(GET_COMPANY_PRODUCTION_VIDEOS);
export const getCompanyLsVodAction = createRoutine(GET_COMPANY_LS_VOD);
export const updateCompanyVideoAction = createRoutine(UPDATE_COMPANY_VIDEO);
export const addCompanyVideoAction = createRoutine(ADD_COMPANY_VIDEO);
export const getCompanyStaffAction = createRoutine(GET_COMPANY_STAFF);
export const updateCompanyInfoAction = createRoutine(UPDATE_COMPANY_INFO);
export const updateCompanyVenueAction = createRoutine(UPDATE_COMPANY_VENUE);
export const getCompanyDescriptionsAction = createRoutine(GET_COMPANY_DESCRIPTIONS);
export const createCompanyDescriptionAction = createRoutine(CREATE_COMPANY_DESCRIPTION);
export const updateCompanyDescriptionAction = createRoutine(UPDATE_COMPANY_DESCRIPTION);
export const deleteCompanyDescriptionAction = createRoutine(DELETE_COMPANY_DESCRIPTION);
export const getCompanyProductionsAction = createRoutine(GET_COMPANY_PRODUCTIONS);
export const getCompanyEmployeesAction = createRoutine(GET_COMPANY_EMPLOYEES);
export const getCompanySearchProductionsAction = createRoutine(GET_COMPANY_SEARCH_PRODUCTIONS_LIST);
export const getCompanyTranslationsAction = createRoutine(GET_COMPANY_TRANSLATIONS);
export const updateCompanyTranslationsAction = createRoutine(UPDATE_COMPANY_TRANSLATIONS);
export const deleteCompanyTranslationsAction = createRoutine(DELETE_COMPANY_TRANSLATIONS);
export const setCompanyProductionRentalAction = createRoutine(SET_COMPANY_PRODUCTION_RENTAL_ACTION);
export const updateRentalIncludesAction = createRoutine(UPDATE_RENTAL_INCLUDES_ACTION);
export const getCompanyYoungArtistProgramAction = createRoutine(GET_COMPANY_YOUNG_ARTIST_PROGRAM);
export const deleteCompanyYoungArtistProgramAction = createRoutine(DELETE_COMPANY_YOUNG_ARTIST_PROGRAM);
export const createCompanyYoungArtistProgramAction = createRoutine(CREATE_COMPANY_YOUNG_ARTIST_PROGRAM);
export const getCompanyFestivalsAction = createRoutine(GET_COMPANY_FESTIVAL);
export const deleteCompanyFestivalAction = createRoutine(DELETE_COMPANY_FESTIVAL);
export const createCompanyFestivalAction = createRoutine(CREATE_COMPANY_FESTIVAL);
export const getAboutCompanyVideoAction = createRoutine(GET_ABOUT_COMPANY_VIDEO);
export const getCompanyReviewsAction = createRoutine(GET_COMPANY_REVIEWS);
export const getCompanyProductionReviewsAction = createRoutine(GET_COMPANY_PRODUCTION_REVIEWS);

export const setCompany = company => ({
  type: SET_COMPANY,
  payload: company,
});

export function setCompanySeasons(seasons) {
  return {
    type: SET_SEASONS,
    payload: { seasons },
  };
}

export function clearCompanyEditSeason() {
  return {
    type: CLEAR_EDIT_SEASONS,
    payload: [],
  };
}

export function deleteCompanyVideoAction(id) {
  return {
    type: DELETE_COMPANY_VIDEO,
    payload: { id },
  };
}
